import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { styled as u, Box as c, CircularProgress as p, Button as g } from "@mui/material";
import f from "react";
import { u as a, s as l } from "./PlaygroundNodes-B1J2GgG-.js";
const m = u(c)({
  position: "relative"
}), b = u(p)({
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: -12,
  marginLeft: -12
});
function C(e) {
  const { isLoading: n, children: o } = e;
  return /* @__PURE__ */ d(m, { children: [
    o,
    n && /* @__PURE__ */ t(b, { size: 24 })
  ] });
}
const L = u((e) => {
  const { pressingColor: n, pressing: o, ...s } = e;
  return /* @__PURE__ */ t(g, { ...s });
})(({ pressing: e, pressingColor: n }) => e ? {
  backgroundColor: n
} : {});
function M(e) {
  const { pressingColor: n, ...o } = e, [s, i] = f.useState(!1);
  return /* @__PURE__ */ t(
    L,
    {
      ...o,
      pressing: s,
      pressingColor: n,
      onMouseUp: (r) => {
        o.onMouseUp && o.onMouseUp(r), i(!1);
      },
      onMouseDown: (r) => {
        o.onMouseDown && o.onMouseDown(r), i(!0);
      },
      onMouseLeave: (r) => {
        o.onMouseLeave && o.onMouseLeave(r), i(!1);
      },
      disableRipple: !0
    }
  );
}
const h = u((e) => /* @__PURE__ */ t(
  M,
  {
    ...e,
    pressingColor: a[700],
    disableElevation: !0
  }
))({
  color: l[100],
  backgroundColor: a[500],
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 12px",
  lineHeight: "20px",
  "&:hover": {
    backgroundColor: a[600]
  },
  "&:disabled": {
    color: l[100],
    backgroundColor: a[500],
    opacity: 0.2
  }
});
function P(e) {
  const {
    children: n,
    isLoading: o,
    onClick: s,
    disabled: i,
    ...r
  } = e;
  return /* @__PURE__ */ t(C, { isLoading: o, children: /* @__PURE__ */ t(h, { onClick: s, disabled: o || i, ...r, children: n }) });
}
export {
  C as L,
  M as P,
  h as a,
  P as b
};
//# sourceMappingURL=index-CkxPCnl7.js.map
